/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RollupType } from '../models/RollupType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RollupTypeService {

    /**
     * get list of roll-up types
     * @returns RollupType Success
     * @throws ApiError
     */
    public static listRollUpTypes({
        surveyJobProfileId,
        limit,
        offset,
        ignorePagination,
    }: {
        /**
         * SurveyJobProfile ID
         */
        surveyJobProfileId: string,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        ignorePagination?: boolean,
    }): CancelablePromise<Array<RollupType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/survey/rollupTypes',
            query: {
                'surveyJobProfileId': surveyJobProfileId,
                'limit': limit,
                'offset': offset,
                'ignorePagination': ignorePagination,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
